export type ScoreTypes = 'tree' | 'meal' | 'education' | 'frame'

const DONATION_PREFIX =
  'Each right answer will add a coin to your mutual score. For every '
const DONATION_MIDDLE = ' coins you win we will '

export const buildDonationText = (
  coinsPerTree: number,
  charityText: string,
): string => `${DONATION_PREFIX}${coinsPerTree}${DONATION_MIDDLE}${charityText}`

export type ScoreType = {
  action: string
  getTitle: (scoreItems: number) => string
  actionPast: string
  /** Charity-specific text (e.g. "plant a REAL tree in..."). Combined with shared prefix + coinsPerTree. */
  donationText?: string
}

const getTitleFactory = (text: string) => (scoreItems: number) =>
  `${text}${scoreItems > 1 ? 's' : ''}`

export const scoreTypes: Record<ScoreTypes, ScoreType> = {
  tree: {
    action: 'plant',
    actionPast: 'planted',
    donationText:
      'plant a REAL tree in the Albertine Rift forests of Uganda to restore and conserve nature for biodiversity while also supporting local communities and our closest wildlife relatives – chimpanzees.',
    getTitle: getTitleFactory('tree'),
  },
  meal: {
    action: 'donate',
    actionPast: 'donated',
    getTitle: getTitleFactory('meal'),
  },
  education: {
    action: 'fund',
    actionPast: 'funded',
    getTitle: getTitleFactory('educational day'),
  },
  frame: {
    action: 'restore',
    actionPast: 'restored',
    getTitle: getTitleFactory('frame'),
  },
}
